import usePageContext from '@rover/react-lib/src/context/usePageContext';
import {
  effects as currentUserEffects,
  selectors as currentUserSelectors,
} from '@rover/react-lib/src/redux/ducks/currentUser.duck';
import {
  UserInformation,
  UserSessionInformationUtmParameters,
} from '@rover/rsdk/src/apiClient/latest';
import { LogoutConfig, useCurrentUser } from '@rover/rsdk/src/modules/Data/Core/CurrentUser';

import useDucks from './useDucks';

type SelectorProps = {
  firstHttpReferrer?: string | null;
  isActiveServiceProvider?: boolean;
  isAuthenticated?: boolean;
  isIdentityVerificationRequired?: boolean;
  isImpersonating?: boolean;
  peopleUrl?: string;
  user?: UserInformation;
  utmParams?: UserSessionInformationUtmParameters;
};

type EffectProps = {
  logout?: (config: LogoutConfig) => void;
};

export type CurrentUserData = SelectorProps & EffectProps;

const selector = (state): CurrentUserData => ({
  firstHttpReferrer: currentUserSelectors.getFirstHttpReferrer(state),
  isActiveServiceProvider: currentUserSelectors.getIsActiveServiceProvider(state),
  isAuthenticated: currentUserSelectors.isAuthenticated(state),
  isIdentityVerificationRequired: currentUserSelectors.getIsIdentityVerificationRequired(state),
  isImpersonating: currentUserSelectors.isImpersonating(state),
  peopleUrl: currentUserSelectors.getPeopleUrl(state),
  user: currentUserSelectors.getCurrentUser(state),
  utmParams: currentUserSelectors.getUtmParams(state),
});

const effects = {
  logout: currentUserEffects.logoutCurrentUser,
};

const useCurrentUserShim = (): CurrentUserData => {
  const { isReactQueryRoute } = usePageContext();
  const data = useCurrentUser({ enabled: isReactQueryRoute });
  const { data: selectedData } = useDucks({ selector, effects });
  return isReactQueryRoute ? data : selectedData;
};

export default useCurrentUserShim;
